import { Component, input } from '@angular/core';
import {CheckboxInputComponent} from "../checkbox-input/checkbox-input.component";
import {DatepickerComponent} from "../datepicker/datepicker.component";
import {EnumSelectComponent} from "../enum-select/enum-select.component";
import {FormInputComponent} from "../form-input/form-input.component";
import {FormSelectComponent} from "../form-select/form-select.component";
import {TranslatePipe} from "@ngx-translate/core";
import { TableColumnModel } from '../../../models/table-column.model';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-filter-form-control',
    imports: [
        CheckboxInputComponent,
        DatepickerComponent,
        EnumSelectComponent,
        FormInputComponent,
        FormSelectComponent,
        TranslatePipe
    ],
  templateUrl: './filter-form-control.component.html',
  styleUrl: './filter-form-control.component.scss'
})
export class FilterFormControlComponent {
  column = input.required<TableColumnModel>();
  filterFormGroup = input.required<FormGroup>();

  getControlName(c: AbstractControl): string | null {
    return (
      Object.keys(c.parent!.controls).find(
        (name) => c === c.parent!.get(name)
      ) || null
    );
  }
}
